import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

import { getAgencyId, getRoles, getUsername } from '@/app/auth/claims';
import { clearSessionInfo, setSessionInfo } from '@/lib/diagnostics';

export function SessionDiagnostics() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      clearSessionInfo();
      return;
    }

    setSessionInfo({
      authenticated: true,
      username: getUsername(user) ?? user.profile.name,
      agencyId: getAgencyId(user),
      subject: user.profile.sub,
      roles: getRoles(user),
      issuer: user.profile.iss,
      expiresAt:
        user.expires_at === undefined ? undefined : new Date(user.expires_at * 1000).toISOString(),
    });

    return clearSessionInfo;
  }, [user]);

  return null;
}
